import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "statistics-screen" }
const _hoisted_2 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ILoader = _resolveComponent("ILoader")!
  const _component_IErrorText = _resolveComponent("IErrorText")!
  const _component_StatisticsTable = _resolveComponent("StatisticsTable")!
  const _component_IModal = _resolveComponent("IModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IModal, { onClose: _ctx.closeModal }, {
      header: _withCtx(() => [
        _createElementVNode("h1", null, _toDisplayString(_ctx.t("statistics.header")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.t("statistics.subheader")), 1)
      ]),
      body: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_ILoader, { key: 0 }))
          : (_ctx.error)
            ? (_openBlock(), _createBlock(_component_IErrorText, {
                key: 1,
                errorMessage: _ctx.error
              }, null, 8, ["errorMessage"]))
            : (_ctx.statisticsItems.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.t("statistics.no_alerts")), 1)
                ]))
              : (_openBlock(), _createBlock(_component_StatisticsTable, {
                  key: 3,
                  items: _ctx.statisticsItems
                }, null, 8, ["items"]))
      ]),
      _: 1
    }, 8, ["onClose"])
  ]))
}